<template>
    <div class="myWorks">
        <!-- <Header></Header> -->
        <!-- <div class="container parentMyworks"> -->
            <el-tabs  @tab-click="setPublish" v-if="!refresh">
                <el-tab-pane label="未发布作品" v-if="look != 'other'" key="未发布作品">
                    <el-radio-group v-model="tabPosition1" style="margin-bottom: 30px;">
                        <el-radio-button label="Scratch">图形化</el-radio-button>
                        <el-radio-button label="Python">Python</el-radio-button>
                    </el-radio-group>
                    <Myworks v-if="publish == '未发布'" :publish="publish" :type="tabPosition1"></Myworks>
                </el-tab-pane>
                <el-tab-pane label="已发布作品" key="已发布作品">
                    <el-radio-group v-model="tabPosition2" style="margin-bottom: 30px;">
                        <el-radio-button label="Scratch">图形化</el-radio-button>
                        <el-radio-button label="Python">Python</el-radio-button>
                    </el-radio-group>
                    <Myworks v-if="publish == '已发布' || this.look == 'other'" :publish="publish" :type="tabPosition2"></Myworks>
                </el-tab-pane>
                <el-tab-pane label="收藏夹" name="收藏夹" key="收藏夹">
                    <Myworks v-if="publish == '收藏夹'" publish="收藏夹" :type="tabPosition2"></Myworks>
                </el-tab-pane>
            </el-tabs>
        <!-- </div> -->
        <!-- <Foot></Foot> -->
    </div>
</template>
<script>
import Header from '@/components/header';
import Foot from '@/components/foot';
import Myworks from '@/components/myworks';
import {mapGetters} from 'vuex'

export default {
    props: ['look', 'refresh'],
    components: {
        Header,
        Foot,
        Myworks,
    },
    computed: {
        ...mapGetters(['studentId']),
    },
    watch: {
        look() {
            if(this.look == 'other') {
                this.publish = "已发布";
            } else {
                this.publish = "未发布";
            }
        }
    },
    data() {
        return {
            publish: '未发布', //区别发布/未发布
            tabPosition1: "Scratch",
            tabPosition2: "Scratch",
        }
    },
    created() {
        if(this.$route.query.id && this.$route.query.id != this.studentId) {
          this.publish = "已发布";
        }
    },
    methods: {
        //传值
        setPublish(item) {
            let result = item.label.slice(0, 3);
            this.publish = result;
        },
    }
}
</script>
<style lang="scss">

.myWorks {
    width: 100%;
    .lawyer,
    .attorney-button {
        background-color: var(--theme-color);
    }
    .lawyer {
        bottom: -96px;
    }
    .team_member:hover .lawyer {
        background-color: var(--theme-color);
    }
    .el-tabs__item.is-active {
        color: var(--theme-activeColor);
    }
    .el-tabs__active-bar {
        background-color: var(--theme-activeColor);
    }
    .el-tabs__item:hover {
        color: var(--theme-color);
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
        border-color: var(--theme-color);
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: var(--theme-color);
        // color: #fff !important;
    }
    .el-radio-button__inner:hover {
        color: var(--theme-color);
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: var(--theme-activeColor);
        border-color: var(--theme-activeColor);
        box-shadow: -1px 0 0 0 var(--theme-activeColor);
    }
}
</style>


// WEBPACK FOOTER //
// src/views/myWorks/myWorks.vue